import React from 'react';
import ComponentHelper from '../../supers/ComponentHelper';
import './environments-panel.css';
import _ from 'lodash';
import RESTService from '../../services/RESTService';
import RoutingService from '../../services/RoutingService';
import Spinner from '../../components/spinner/Spinner';
import TimeAgo from 'react-timeago';
import conciergeLogo from './c-logo.png';
import CommonService from '../../services/CommonService';
import InstallAppModal from './install-app-modal/InstallAppModal';
import ProvisionModal from './provision-modal/ProvisionModal';
import CreateEnvironmentModal from './create-environment-modal/CreateEnvironmentModal';
import DialogModal from '../../components/dialog-modal/DialogModal';
const connect = new RESTService();
const RS = new RoutingService();
const CS = new CommonService();
class EnvironmentsPanel extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			envs: [],
			envMap: {},
			flippedApp: '',
			openMenu: false,
			loading: true,
			showInstaller: false,
			installTo: null,
			provisionTo: '',
			showProvision: false,
			showCreate: false,
			showDeleteModal: false
		};
		this.autoBindAll(this);
	}

	componentDidMount() {
		this.loadEnvironments();
	}

	loadEnvironments() {
		connect
			.getTenantEnvironments(RS.getCurrentTenant())
			.then(res => {
				this.observe(() => {
					let sortedEnvs = [];
					let order = ['dev', 'qa', 'uat', 'prod'];
					let envMap = {};
					for (let i = 0; i < res.data.length; i++) {
						let key = res.data[i].name.toLowerCase();
						envMap[key] = res.data[i];
					}
					order.forEach(key => {
						sortedEnvs.push(envMap[key]);
						delete envMap[key];
					});
					let others = Object.values(envMap);
					others.sort(function(a, b) {
						var c = new Date(a.creationDate);
						var d = new Date(b.creationDate);
						return c - d;
					});
					this.data.envs = sortedEnvs.concat(others);
					this.data.envMap = CS.mapByParam('name', this.data.envs);
					this.data.loading = false;
					if (!RS.getCurrentEnvironment() || RS.getCurrentEnvironment().length <= 0) {
						RS.setCurrentEnvironment('dev');
					}
				});
			})
			.catch(err => {
				this.setData('loading', false);
				RS.smartError(err);
			});
	}

	handleCardClick(evt) {
		evt.stopPropagation();
		this.onCloseOpenMenu();
	}

	flipCard(evt) {
		this.handleCardClick(evt);
		let env = evt.currentTarget.dataset.env;
		if (env && env !== RS.getCurrentEnvironment()) {
			RS.setCurrentEnvironment(env);
			this.pushChanges();
		}
		let classes = evt.currentTarget.classList;
		if (this.data.envMap[env].installedApps) {
			classes = evt.target.closest('.flip-ctn').classList;
		}
		if (classes.contains('flipped')) {
			classes.remove('flipped');
		} else {
			classes.add('flipped');
			this.setData('flippedApp', evt.currentTarget.dataset.app);
		}
	}

	onEditEntities(evt) {
		this.handleCardClick(evt);
		RS.setCurrentEnvironment(evt.target.dataset.env);
		RS.setCurrentApplication(null);
		RS.goToRoute('/entities/models');
	}

	onEditEndpoints(evt) {
		this.handleCardClick(evt);
		RS.setCurrentEnvironment(evt.target.dataset.env);
		RS.setCurrentApplication(null);
		RS.goToRoute('/endpoints');
	}

	onOpenMenu(evt) {
		this.handleCardClick(evt);
		let el = evt.target.parentElement.getElementsByClassName('menu-items')[0];
		if (el && el.classList.contains('hidden')) {
			el.classList.remove('hidden');
			this.setData('openMenu', el);
		}
	}

	onProvision(evt) {
		this.handleCardClick(evt);
		let env = evt.target.dataset.env;
		RS.setCurrentEnvironment(env);
		let obj = this.data.envMap[env];
		//TODO make this work for both
		if (obj && obj.installedApps && obj.installedApps[this.data.flippedApp]) {
			connect
				.getAppConfig(obj.installedApps[this.data.flippedApp], env)
				.then(res => {
					if (res && res.data) {
						RS.setCurrentApplication(res.data.name);
						RS.setCurrentConfiguration(res.data);
						this.observe(() => {
							this.data.showProvision = true;
							this.data.provisionTo = env;
						});
					}
				})
				.catch(err => {
					RS.smartError(err);
				});
		}
	}

	closeProvision = () => {
		this.setData('showProvision', false);
	};

	onMigrate(evt) {
		this.handleCardClick(evt);
	}

	onConfigure(evt) {
		this.handleCardClick(evt);
		let env = evt.target.dataset.env;
		RS.setCurrentEnvironment(env);
		let obj = this.data.envMap[env];
		if (obj && obj.installedApps && obj.installedApps[this.data.flippedApp]) {
			connect
				.getAppConfig(obj.installedApps[this.data.flippedApp], env)
				.then(res => {
					if (res && res.data) {
						RS.setCurrentApplication(res.data.name);
						RS.setCurrentConfiguration(res.data);
						RS.goToRoute('/modules');
					}
				})
				.catch(err => {
					RS.smartError(err);
				});
		}
	}

	onArchive(evt) {
		this.handleCardClick(evt);
		let env = evt.target.dataset.env;
		RS.setCurrentEnvironment(env);
		this.toggleDeleteModal();
	}

	onCloseOpenMenu() {
		if (this.data.openMenu) {
			this.data.openMenu.classList.add('hidden');
			this.setData('openMenu', null);
		}
	}

	onManageTags(evt) {
		this.handleCardClick(evt);
	}

	closeInstaller() {
		this.setData('showInstaller', false);
	}

	installComplete() {
		this.closeInstaller();
		this.loadEnvironments();
	}

	createComplete() {
		this.toggleCreate();
		this.loadEnvironments();
	}

	onInstallApp(evt) {
		this.handleCardClick(evt);
		let name = evt.target.dataset.env;
		if (name) {
			let env = this.data.envMap[name];
			if (env) {
				this.observe(() => {
					this.data.showInstaller = true;
					this.data.installTo = env;
				});
			}
		}
	}

	toggleCreate() {
		this.setData('showCreate', !this.data.showCreate);
	}

	canDelete = env => {
		let n = env.name.toLowerCase();
		if (n !== 'dev' && n !== 'qa' && n !== 'uat' && n !== 'prod') {
			return true;
		}
		return false;
	};

	onDeleteEnv = evt => {
		this.handleCardClick(evt);
		let name = evt.target.dataset.env;
		if (name) {
			let env = this.data.envMap[name];
			if (env) {
				RS.setCurrentEnvironment(name);
				connect
					.deleteEnvironment()
					.then(() => {
						RS.setCurrentEnvironment('dev');
						this.loadEnvironments();
					})
					.catch(err => {
						RS.smartError(err);
					});
			}
		}
	};

	buildInstalledApps(env) {
		let logos = [];
		_.forEach(Object.keys(env.installedApps), app => {
			if (app === 'concierge') {
				logos.push(
					<img
						src={conciergeLogo}
						data-rh={`Concierge`}
						key="concierge-logo"
						data-rh-at="top"
						data-app={app}
						alt="Concierge"
						onClick={this.flipCard}
						data-env={env.name}
					/>
				);
			} else {
				logos.push(
					<div
						className="vbox vcenter hcenter letter-logo"
						key={`${app}-logo`}
						onClick={this.flipCard}
						data-app={app}
						data-env={env.name}
						data-rh={_.capitalize(app)}
						data-rh-at="top"
					>
						<div>{app.toUpperCase().charAt(0)}</div>
					</div>
				);
			}
		});
		return <div className="installed-apps hbox vcenter">{logos}</div>;
	}

	buildSelectedApp(env) {
		let { flippedApp } = this.data;
		return (
			<div className={`back ${flippedApp}`}>
				<div className="card-header hbox hright vcenter">
					<div className="action hbox vcenter" data-rh="Provision" data-rh-at="top" data-env={env.name} onClick={this.onProvision}>
						<i className="mdi mdi-qrcode-scan" data-env={env.name} />
					</div>
					<div className="w-100" />
					<i className="mdi mdi-close" data-env={env.name} onClick={this.flipCard} />
				</div>
				<div className="card-content vbox vcenter hcenter">
					<div className="app-name">{flippedApp}</div>
				</div>
				<div className="app-actions">
					<div className="action hbox vcenter" data-env={env.name} onClick={this.onConfigure}>
						<i className="mdi mdi-settings" /> Configure
					</div>
					<div className="action hbox vcenter" onClick={this.onMigrate}>
						<i className="mdi mdi-cloud-download" /> Import
					</div>
					<div className="action hbox vcenter" onClick={this.onMigrate}>
						<i className="mdi mdi-cloud-upload" /> Export
					</div>
					<div className="action hbox vcenter" data-env={env.name} onClick={this.onArchive}>
						<i className="mdi mdi-archive" /> Archive
					</div>
				</div>
			</div>
		);
	}

	buildEnvCards() {
		let cards = [
			<div className="env-card shadow hover animated zoomIn new-env" key="env-card-key-create" onClick={this.toggleCreate}>
				<div className="front">
					<div className="card-content vbox hcenter vcenter grow-1 new-env">
						<div className="card-title capitalize">
							Create<br />Environment
						</div>
						<i className="mdi mdi-plus" />
					</div>
					<div className="card-footer" />
				</div>
			</div>
		];
		for (let i = 0; i < this.data.envs.length; i++) {
			let env = this.data.envs[i];
			let appInstalled = env.installedApps && Object.keys(env.installedApps).length > 0;
			cards.push(
				<div className="flip-ctn" onClick={appInstalled ? null : this.flipCard} key={`env-card-key-${env.name}`} data-env={env.name}>
					<div className="env-card shadow hover animated zoomIn">
						<div className="front">
							<div className="card-header hbox hright vcenter">
								<div className={`current-tag grow-1 ${RS.getCurrentEnvironment() === env.name ? '' : 'hidden'}`}>
									<div className="tag">Current</div>
								</div>
								<div className="menu-items animated zoomIn hidden">
									<div className="item hbox vcenter" onClick={this.onManageTags}>
										<i className="mdi mdi-tag-multiple" /> Manage Tags
									</div>
									<div className="item hbox vcenter" data-env={env.name} onClick={this.onInstallApp}>
										<i className="mdi mdi-settings" /> Install App
									</div>
									{this.canDelete(env) && (
										<div className="item hbox vcenter" data-env={env.name} onClick={this.onDeleteEnv}>
											<i className="mdi mdi-delete" /> Delete
										</div>
									)}
								</div>
								<i className="mdi mdi-dots-horizontal" onClick={this.onOpenMenu} />
							</div>
							<div className="card-content vbox hcenter">
								<div className="card-title">{env.name}</div>
								<div className="app-description ellipse" title={env.description}>
									{env.description || `${env.name} Environment`}
								</div>
								<div className="divider" />
								<div className="created">
									Created: <TimeAgo date={env.creationDate} />
								</div>
								{env.installedApps && Object.keys(env.installedApps).length > 0 ? this.buildInstalledApps(env) : ''}
							</div>
							<div className={`${appInstalled ? 'card-footer hbox vcenter' : 'hidden'}`}>
								<div className="card-btn entities hbox vcenter hcenter" data-env={env.name} onClick={this.onEditEntities}>
									<i className="mdi mdi-shape-plus" data-env={env.name} /> Entities
								</div>
								<div className="card-btn endpoints hbox vcenter hcenter" data-env={env.name} onClick={this.onEditEndpoints}>
									<i className="mdi mdi-source-branch" data-env={env.name} /> Endpoints
								</div>
							</div>
						</div>
						{appInstalled && this.buildSelectedApp(env)}
						{!appInstalled && (
							<div className="back no-apps">
								<div className="card-header hbox hright vcenter">
									<i className="mdi mdi-close" />
								</div>
								<div className="installer" onClick={this.onInstallApp} data-env={env.name}>
									Install App
								</div>
							</div>
						)}
					</div>
				</div>
			);
		}
		return cards;
	}

	onConfirmDelete() {
		connect
			.deleteAppConfiguration({ name: this.data.flippedApp })
			.then(() => {
				let env = this.data.envMap[RS.getCurrentEnvironment()];
				delete env.installedApps[this.data.flippedApp];
				connect
					.updateEnvironment(env)
					.then(() => {
						this.toggleDeleteModal();
						this.observe(() => {
							this.data.flippedApp = '';
						});
						RS.showSuccess();
					})
					.catch(err => {
						this.toggleDeleteModal();
						RS.smartError(err);
					});
			})
			.catch(err => {
				RS.smartError(err);
				this.toggleDeleteModal();
			});
	}

	toggleDeleteModal() {
		this.setData('showDeleteModal', !this.data.showDeleteModal);
	}

	render() {
		let { loading, openMenu, showInstaller, showProvision, installTo, provisionTo, showCreate, showDeleteModal } = this.data;
		return (
			<div className="environments-panel-view">
				{openMenu && <div className="menu-mask" onClick={this.onCloseOpenMenu} />}
				{loading && <Spinner text={`Loading environments`} />}
				{!loading && <div className="env-card-list">{this.buildEnvCards()}</div>}
				<CreateEnvironmentModal isOpen={showCreate} onClose={this.toggleCreate} onComplete={this.createComplete} />
				<ProvisionModal isOpen={showProvision} onClose={this.closeProvision} environment={provisionTo} />
				<InstallAppModal isOpen={showInstaller} onClose={this.closeInstaller} onComplete={this.installComplete} environment={installTo} />
				<DialogModal
					isOpen={showDeleteModal}
					type="warning"
					showCancelButton={true}
					cancelBtnText="No"
					confirmBtnText="Yes"
					text="Are  you sure you want to archive this application?"
					title="Are you sure?"
					onConfirm={this.onConfirmDelete}
					onCancel={this.toggleDeleteModal}
				/>
			</div>
		);
	}
}

export default EnvironmentsPanel;



// WEBPACK FOOTER //
// ./src/views/environments-panel/EnvironmentsPanel.js